import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  open(event) {
    event?.preventDefault()
    if (!this.hasPanelTarget) return
    this.panelTarget.hidden = false
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasPanelTarget) return
    this.panelTarget.hidden = true
  }
}
